import { render, staticRenderFns } from "./EducationPage.vue?vue&type=template&id=4d642926&scoped=true&lang=pug"
import script from "./EducationPage.vue?vue&type=script&lang=js"
export * from "./EducationPage.vue?vue&type=script&lang=js"
import style0 from "./EducationPage.vue?vue&type=style&index=0&id=4d642926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d642926",
  null
  
)

export default component.exports